import React from "react";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { getFullImageUrl } from "../services/api";

const MegaSaleBanner = ({ content }) => {
  // Fallback data if no content is provided
  const data = content || {
    title: "MEGA SALE",
    subtitle: "Technology Style",
    highlight: "GIẢM ĐẾN 50%",
    description: "Chất Lượng Vượt Trội",
    link: "/products",
    buttonText: "Mua Ngay",
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAworlvPiwYSa1EcyC8fpimnYwu-D9XZb4Bzz4QC4b6HMa4ECt8QDy8WASc4f8CRDblk-BTGQD0NT8wdOJWvfPKwofZxRBIklWGxohQTdXZkcxraaP_IAnpKyV7qJjlvET7TLDV1AfVxbDyDOCfFjk0oPxZ6da6H2ULtAaMDv_kqeSMfEW04Jt4cqj0daIaHc75jFV0XLIyJPrHE3lbtgi1HajiyKi1f2PBGfIUJYF9M7cXVSM8kxvuz_phiJSgmQqDgPaqgImQ4DU"
  };

  const titleParts = data.title.split(" ");
  const firstWord = titleParts[0];
  const remainingWords = titleParts.slice(1).join(" ");

  return (
    <div className="w-full bg-techWhite dark:bg-slate-950 overflow-hidden relative tech-grid py-2 md:py-12 border-b border-gray-100 dark:border-slate-900 transition-colors duration-500">
      {/* Decorative Tech Elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-10 left-10 w-24 h-24 border-l-4 border-t-4 border-blue-600 opacity-20"></div>
        <div className="absolute bottom-10 right-10 w-24 h-24 border-r-4 border-b-4 border-blue-600 opacity-20"></div>
        <div className="absolute top-1/2 left-0 w-1/4 h-px bg-gradient-to-r from-blue-600 to-transparent opacity-10"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center gap-6 md:gap-12 relative z-10">
        {/* Text Content */}
        <div className="w-full md:w-1/2 flex flex-col gap-3 sm:gap-4 text-center md:text-left items-center md:items-start">
          {/* Logo Area */}
          <div className="flex items-center gap-2 sm:gap-4 mb-0.5 sm:mb-1">
            <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full border-[1px] border-white flex items-center justify-center text-white font-bold shadow-lg overflow-hidden bg-white">
              <img
                src={logo}
                alt="logo"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-base sm:text-xl font-black tracking-tighter text-slate-900 dark:text-white transition-colors uppercase">
              TAHA <span className="text-red-600">SHOES</span>
            </span>
          </div>

          {/* Headline */}
          <div className="space-y-0 sm:space-y-0.5">
            <p className="text-blue-600 dark:text-blue-400 font-black text-[10px] sm:text-xs tracking-[0.3em] uppercase transition-colors">
              {data.subtitle}
            </p>
            <h1 className="text-2xl sm:text-4xl lg:text-5xl leading-[0.9] font-black italic text-slate-900 dark:text-white uppercase tracking-tighter transition-colors">
              {firstWord} <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-400 dark:from-blue-500 dark:to-cyan-300">
                {remainingWords}
              </span>
            </h1>
          </div>

          {/* Promotion Details */}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 sm:gap-4 mt-0.5">
            <div className="bg-slate-900 dark:bg-blue-600 text-white px-2 py-1 sm:px-4 sm:py-2 rounded-none skew-x-[-12deg] shadow-xl transition-colors">
              <span className="block text-xs sm:text-2xl font-black tracking-tight skew-x-[12deg]">
                {data.highlight}
              </span>
            </div>
            <div className="text-slate-900 dark:text-slate-300 border-l-2 sm:border-l-4 border-blue-600 pl-3 sm:pl-4 transition-colors">
              <p className="text-xs sm:text-lg font-black uppercase leading-tight italic text-left">
                {data.description.split(" ").map((word, i) => (
                  <React.Fragment key={i}>{word} {i === 0 ? <br /> : ""}</React.Fragment>
                ))}
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-2 sm:mt-4">
            <Link to={data.link}>
              <button className="bg-blue-600 text-white text-xs sm:text-lg font-black px-4 py-2 sm:px-8 sm:py-3 rounded-full hover:bg-blue-700 transition-all transform active:scale-95 uppercase tracking-widest shadow-2xl animate-glow">
                {data.buttonText}
              </button>
            </Link>
          </div>
        </div>

        {/* Visual Content */}
        <div className="w-full md:w-1/2 relative hidden md:flex items-center justify-center py-2 md:py-0">
          {/* Background Circle Glow */}
          <div className="absolute w-[300px] h-[300px] md:w-[320px] md:h-[320px] bg-blue-600 opacity-10 rounded-full blur-[80px]"></div>

          {/* Large Background Text */}
          <div className="absolute inset-0 flex items-center justify-center select-none overflow-hidden pointer-events-none">
            <span className="text-[100px] md:text-[150px] font-black text-gray-200 dark:text-slate-900 opacity-20 leading-none transition-colors">
              TAHA
            </span>
          </div>

          {/* Main Product Image Container */}
          <div className="relative z-20 transform -rotate-[15deg] transition-transform duration-700 hover:rotate-0 drop-shadow-2xl">
            <img
              alt="Premium TaHa Sneaker"
              className="max-w-[70%] md:max-w-[350px] object-contain"
              src={getFullImageUrl(data.image)}
            />

            {/* Callout Points */}
            <div className="absolute top-4 -right-2 md:-right-6 bg-white/90 dark:bg-slate-800/90 backdrop-blur-md p-2 md:p-3 border-l-4 border-blue-600 shadow-lg rotate-[15deg] hidden sm:block transition-colors">
              <p className="text-slate-900 dark:text-white font-bold text-xs md:text-sm uppercase tracking-wider">
                Thiết kế tương lai
              </p>
            </div>
            <div className="absolute bottom-4 -left-2 md:-left-6 bg-white/90 dark:bg-slate-800/90 backdrop-blur-md p-2 md:p-3 border-l-4 border-blue-600 shadow-lg rotate-[15deg] hidden sm:block transition-colors">
              <p className="text-slate-900 dark:text-white font-bold text-xs md:text-sm uppercase tracking-wider">
                Êm ái tuyệt đối
              </p>
            </div>
          </div>

          {/* Floating UI element */}
          <div className="absolute bottom-0 right-0 text-right opacity-40 hidden md:block">
            <p className="text-blue-600 font-mono text-sm tracking-widest uppercase">
              V2.4 PERFORMANCE SYSTEM
            </p>
            <div className="h-0.5 w-32 bg-gradient-to-l from-blue-600 to-transparent mt-1 ml-auto"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaSaleBanner;
